module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/credits-large.9db50770.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/credits-large.png
// module id = 2670
// module chunks = 11